<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select
                class="selectBox"
                style="display:inline-block;width:100px;"
                v-model="formData.range"
              >
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="YEARLY">년간</option>
              </select>

              <!-- 일간 -->
              <DatePicker
                v-if="formData.range === 'DAILY'"
                :value="$utils.calcDate(null, '-1d')"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(new Date(), '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker
                v-if="formData.range === 'MONTHLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <YearPicker
                v-if="formData.range === 'YEARLY'"
                class="blank"
                ref="picker"
                minDate="2017"
                :maxDate="new Date()"
              />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :useGroup="false" ref="groupSelector" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->
    <div v-if="res" ref="tableWrap">
      <h4 class="section_title">
        <span class="ico"></span>등록건수 / 등록자수
      </h4>
      <div class="section_textarea">
        <span>
          일반소식 : {{res.normalCount}}
          <span class="tab">|</span>
          반복소식 : {{res.repeatCount}}
          <span class="tab">|</span>
          맞춤소식 : {{res.customCount}}
        </span>
        <p class="desc">※ 기간 외에 조회 조건 무관</p>
      </div>

      <h4 class="section_title">
        <span class="ico"></span>
        전송건수 / 수신자수 / 확인건수 / 확인자수
      </h4>
      <ItemTable :itemArray="res.allNewsList" listKey="all" divName="전체" />

      <h4 class="section_title">
        <span class="ico"></span>
        지역별 전송건수 / 수신자수 / 확인건수 / 확인자수
      </h4>
      <ItemTable :itemArray="res.areaNewsList" listKey="area" divName="지역" />

      <h4 class="section_title">
        <span class="ico"></span>
        연령대별 전송건수 / 수신자수 / 확인건수 / 확인자수
      </h4>
      <ItemTable :itemArray="res.ageNewsList" listKey="age" divName="연령대" />
    </div>

    <div class="section_button none_paginate">
      <ExcelDownloadButton
        v-if="res"
        :filename="$utils.excelName('소식톡톡통계')"
        :tablesContainer="$refs.tableWrap"
      />
      <HelpButton contentId="HELP_03" />
    </div>
  </section>
</template>

<script>
import ItemTable from "./ItemTable";
import XLSX from "xlsx";

export default {
  components: { ItemTable },
  data() {
    return {
      res: null,
      formData: {
        range: "WEEKLY",
        state: "",
        city: ""
      }
    };
  },
  computed: {},
  methods: {
    loadData() {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/news", options)
        .then(({ data }) => {
          // 테이블 컴포넌트에서 바로 쓸수 있도록 key값 일치화
          // ['allNewsList', ]
          this.res = data;
        });
    },
    requestOptions() {
      const startDate = this.$refs.picker.getDate();
      const group = this.$refs.groupSelector.getData();

      return {
        params: _.merge(this.formData, {
          searchDate: this.$utils.dateText(startDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId
        })
      };
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
